import { axiosClient } from '@/libs/axios-client';

const BASE = '/team-assignments';

export const getTeamBoard = async ({ clientStatus } = {}) => {
  const { data } = await axiosClient.get(`${BASE}/board`, {
    params: clientStatus?.length ? { clientStatus: clientStatus.join(',') } : {},
  });
  return data;
};

export const getTeamCompanyCard = async (companyId) => {
  const { data } = await axiosClient.get(`${BASE}/companies/${companyId}`);
  return data;
};

export const createTeamAssignment = async (payload) => {
  const { data } = await axiosClient.post(BASE, payload);
  return data;
};

export const transferTeamAssignment = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/transfer`, payload);
  return data;
};

export const finishTeamTransition = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/finish-transition`, payload);
  return data;
};

export const updateTeamAssignment = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/update`, payload);
  return data;
};

export const endTeamAssignment = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/end`, payload);
  return data;
};

export const confirmMyTeamCompanies = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/confirm`, payload);
  return data;
};

export const resolveTeamIssue = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/resolve-issue`, payload);
  return data;
};

export const updateClientStatus = async (companyId, payload) => {
  const { data } = await axiosClient.put(`${BASE}/companies/${companyId}/client-status`, payload);
  return data;
};

// `revision` is the version the list was read at: a save made since answers 409.
export const updateClientContacts = async (companyId, contacts, revision) => {
  const { data } = await axiosClient.put(`${BASE}/contacts/companies/${companyId}`, { contacts, revision });
  return data;
};

export const getTeamContactsDetail = async (companyId) => {
  const { data } = await axiosClient.get(`${BASE}/contacts/companies/${companyId}`);
  return data;
};

export const confirmTeamContacts = async (companyId, revision) => {
  const { data } = await axiosClient.post(`${BASE}/contacts/companies/${companyId}/confirm`, { revision });
  return data;
};

export const getTeamContactsSummary = async () => {
  const { data } = await axiosClient.get(`${BASE}/contacts/summary`);
  return data;
};

export const getTeamContactsMailing = async (companyId) => {
  const { data } = await axiosClient.get(`${BASE}/contacts/companies/${companyId}/mailing`);
  return data;
};

export const updateTeamContactsMailing = async (companyId, payload) => {
  const { data } = await axiosClient.put(`${BASE}/contacts/companies/${companyId}/mailing`, payload);
  return data;
};

// The client's own side.
export const listMyClientSideCompanies = async () => {
  const { data } = await axiosClient.get(`${BASE}/client-contacts`);
  return data;
};

export const getClientSideContacts = async (companyId) => {
  const { data } = await axiosClient.get(`${BASE}/client-contacts/${companyId}`);
  return data;
};

export const updateClientSideContacts = async (companyId, contacts, revision) => {
  const { data } = await axiosClient.put(`${BASE}/client-contacts/${companyId}`, { contacts, revision });
  return data;
};

export const confirmClientSideContacts = async (companyId, revision) => {
  const { data } = await axiosClient.post(`${BASE}/client-contacts/${companyId}/confirm`, { revision });
  return data;
};

// The mail to clients.
export const getContactCampaign = async (params) => {
  const { data } = await axiosClient.get(`${BASE}/contact-campaign`, { params });
  return data;
};

export const getCampaignTemplate = async () => {
  const { data } = await axiosClient.get(`${BASE}/contact-campaign/template`);
  return data;
};

export const saveCampaignTemplate = async (payload) => {
  const { data } = await axiosClient.put(`${BASE}/contact-campaign/template`, payload);
  return data;
};

export const previewCampaign = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/preview`, payload);
  return data;
};

export const testCampaign = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/test`, payload);
  return data;
};

export const sendCampaign = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/send`, payload);
  return data;
};

export const remindCampaign = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/remind`, payload);
  return data;
};

export const createContactAccount = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/accounts`, payload);
  return data;
};

export const sendContactInvitations = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/contact-campaign/invitations`, payload);
  return data;
};

export const getTeamSettings = async () => {
  const { data } = await axiosClient.get(`${BASE}/settings`);
  return data;
};

export const updateTeamSettings = async (payload) => {
  const { data } = await axiosClient.put(`${BASE}/settings`, payload);
  return data;
};

export const exportTeamBoard = async ({ clientStatus } = {}) => {
  const { data } = await axiosClient.get(`${BASE}/export`, {
    params: clientStatus?.length ? { clientStatus: clientStatus.join(',') } : {},
    responseType: 'blob',
  });
  return data;
};

// Client contacts of the companies the caller sees: one row per company.
export const getTeamContacts = async (params) => {
  const { data } = await axiosClient.get(`${BASE}/contacts`, { params });
  return data;
};

export const exportTeamContacts = async (params) => {
  const { data } = await axiosClient.get(`${BASE}/contacts/export`, { params, responseType: 'blob' });
  return data;
};

export const getTeamPersonSummary = async ({ userId, employeeId }) => {
  const { data } = await axiosClient.get(`${BASE}/person-summary`, { params: { userId, employeeId } });
  return data;
};

export const getTeamHomeSummary = async () => {
  const { data } = await axiosClient.get(`${BASE}/home-summary`);
  return data;
};

export const createTeamSubstitution = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/substitutions`, payload);
  return data;
};

export const cancelTeamSubstitution = async (substitutionId) => {
  const { data } = await axiosClient.post(`${BASE}/substitutions/${substitutionId}/cancel`);
  return data;
};

export const bulkTransferTeam = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/bulk-transfer`, payload);
  return data;
};

export const copyTeamFromSibling = async (payload) => {
  const { data } = await axiosClient.post(`${BASE}/copy-from-sibling`, payload);
  return data;
};

// General admin tasks (not one client's).
export const getTeamTasks = async () => {
  const { data } = await axiosClient.get(`${BASE}/tasks`);
  return data;
};

export const saveTeamTask = async ({ _id, ...payload }) => {
  const { data } = _id
    ? await axiosClient.put(`${BASE}/tasks/${_id}`, payload)
    : await axiosClient.post(`${BASE}/tasks`, payload);
  return data;
};

export const archiveTeamTask = async (taskId) => {
  const { data } = await axiosClient.post(`${BASE}/tasks/${taskId}/archive`);
  return data;
};

export const markTeamTask = async ({ taskId, done, period }) => {
  const { data } = await axiosClient.post(`${BASE}/tasks/${taskId}/done`, { done, period });
  return data;
};
